export const ACCEPTED_MEDIA_TYPES = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'image/heic',
  'image/heif',
  'image/tiff',
];

export const MAX_FILE_SIZE_LIMIT = 10; // in Mb

export const ACCEPTED_MEDIA_TYPES_MESSAGE = 'Only PNG, JPG, and TIFF files will be accepted';


export function isMediaTypeAccepted(mediaType) {
  return ACCEPTED_MEDIA_TYPES.includes(mediaType);
}
